import type {Dayjs} from 'dayjs'

export const formatIsoMonth = (date: Dayjs): string => {
  return date.startOf('month').format('YYYY-MM')
}
